import invariant from 'tiny-invariant';
import {
  actions,
  ActorRefFrom,
  assign,
  createMachine,
  forwardTo,
  interpret,
  send,
  spawn,
} from 'xstate';
import { isRequestMessage } from '../helpers';
import { Message, ServiceID } from '../types';
import { service } from './serviceActor';

let { pure, stop } = actions;

type Context = {
  children: {
    [id: ServiceID]: ActorRefFrom<typeof service>;
  };
};

export let hub = createMachine<Context, Message>(
  {
    id: 'message_hub',
    meta: {
      description:
        __DEV__ &&
        'Управляет распределением запросов по приложениям. Точка входа в логику очередей.',
    },
    context: {
      children: {},
    },
    initial: 'working',
    states: {
      working: {
        on: {
          save: { actions: ['forward_to_service_actor'] },
          load: { actions: ['forward_to_service_actor'] },
          delete: { actions: ['forward_to_service_actor'] },
          stop_child: { actions: ['stop_child'] },
        },
      },
    },
  },
  {
    actions: {
      stop_child: pure((ctx, message) => {
        invariant(message.type === 'stop_child');
        let actions = [];
        let { id } = message;
        let children = { ...ctx.children };
        if (id in ctx.children) {
          actions.push(stop<Context, Message>(() => ctx.children[id]));
          delete children[id];
          actions.push(assign<Context, Message>({ children }));
        }
        if (Object.keys(children).length === 0) {
          actions.push(send<Context, Message>('stop_working'));
        }
        return actions;
      }),
      forward_to_service_actor: pure((ctx, message) => {
        isRequestMessage(message);
        let actions = [];
        let id: ServiceID = message.serviceID;
        let actorRef: Context['children'][ServiceID] = ctx.children[id];
        if (!actorRef) {
          actorRef = spawn(service.withContext({ id, children: {} }), id);
          actions.push(
            assign<Context, Message>({
              children: (ctx) => ({ ...ctx.children, [id]: actorRef }),
            })
          );
        }
        actions.push(forwardTo<Context, Message>(() => actorRef));
        return actions;
      }),
    },
  }
);

export let requestHub = interpret(hub).start();
